import { init as initProducts } from "products/app";

export const init = () => {
  initProducts();
}